<template>
  <Mutation
    :mutation="mutation"
    :variables="variables"
    @done="onDone"
    @error="onError"
  >
    <template v-slot="{ mutate, loading }">

      <button class="border rounded p-2 text-gray-600 hover:bg-gray-200" @click="confirmationModalOpen = true">
        Disable this Teacher
      </button>
      <portal to="modals">
        <div
          class="z-50 fixed w-full h-full top-0 flex items-center bg-black/50"
          v-show="confirmationModalOpen"
          @click="didCancel"
          @keyup.escape="didCancel"
        >
          <div class="rounded shadow-lg max-w-lg bg-white mx-auto mt-16 p-8" @click.stop>
            <div class="text-center mb-4 text-2xl font-bold">Are you sure?</div>
            <div class="text-center text-gray-600er mb-6">
              <p class="mb-2 text-left">
                Disabling a teacher will also release their Cardstock number. Families will no longer be able to text or call this number.
              </p>
              <p class="text-left">
                This action cannot be undone.
              </p>
            </div>
            <div class="flex justify-around">
              <button class="py-2 px-4 rounded cursor-pointer text-center whitespace-nowrap border-gray-300 border-2" @click="didCancel">Cancel</button>
              <button
                class="text-white py-2 px-4 rounded cursor-pointer bg-red-600 hover:bg-red-700 text-center whitespace-nowrap"
                @click="mutate"
                :disabled="loading"
              >
                Disable the teacher's account
                <font-awesome-icon v-show="loading" class="ml-2" :icon="['far', 'spinner']" spin/>
              </button>
            </div>
          </div>
        </div>
      </portal>

    </template>
  </Mutation>
</template>

<script>
import _get from 'lodash-es/get'
import Mutation from '@/components/Mutation.vue'
import TeacherDisableMutation from '@/mutations/TeacherDisable.gql'

export default {
  components: {
    Mutation
  },

  props: {
    teacher: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      confirmationModalOpen: false,
      mutation: TeacherDisableMutation
    }
  },

  computed: {
    variables() {
      return {
        id: _get(this, 'teacher.id')
      }
    },

    displayName() {
      const first = _get(this, 'teacher.first')
      const last = _get(this, 'teacher.last')
      const email = _get(this, 'teacher.email')

      if (first && last) {
        return first + ' ' + last
      } else if (first) {
        return first
      } else if (last) {
        return last
      } else {
        return email
      }
    }
  },

  methods: {
    didCancel() {
      this.confirmationModalOpen = false
    },

    onDone() {
      this.confirmationModalOpen = false
    },

    onError(e) {
      Bus.$emit('flash-message', {text: e, type: 'error'})
    }
  }
}
</script>
